//? Library Imports ------------------------------------------------------------>
import {
  Col,
  Row,
  Spin,
  Space,
  Input,
  Button,
  message,
  Skeleton,
  Typography,
  Pagination,
} from "antd";
import debounce from "lodash/debounce";
import { useSelector, useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { useCallback, useEffect, useState } from "react";

//? Assets --------------------------------------------------------------------->
import { CiFilter } from "react-icons/ci";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import OrderCard from "./OrderCard/OrderCard";
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
//? Library Constants ---------------------------------------------------------->
const { Search } = Input;
const { Text } = Typography;

export default function OrdersListingModule(
  {
    // Loading,
    // OrdersList,
    // OrdersDetail,
    // fetchOrderDetails,
  }
) {
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();

  //? Hooks ---------------------------------------------------------------------->
  const router = useRouter();

  //? Redux States --------------------------------------------------------------->
  const dispatch = useDispatch();
  //? States --------------------------------------------------------------------->
  const [Loading, setLoading] = useState(false);
  const [ActivePage, setActivePage] = useState(1);
  const [CustomerOrders, setCustomerOrders] = useState({});

  //? Functions ------------------------------------------------------------------>
  const searchOrders = async (query) => {
    if (comverse_customer_token) {
      try {
        setLoading(true);
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "GET",
          headers: headers,
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
            `/storefront/customer_orders?search=${query}`,
          payload
        );

        const data = await res.json();

        if (!res.ok) {
          throw new Error("Orders Search Api Api Failed!");
        }

        setCustomerOrders(data);
        setLoading(false);
        return data;
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  };

  // const searchQuery = useCallback(debounce(searchOrders, 1000), []);

  const fetchCustomerOrders = useCallback(
    async (page) => {
      if (comverse_customer_token) {
        try {
          setLoading(true);
          const headers = {
            "Content-Type": "application/json",
          };
          if (comverse_customer_token) {
            headers.Authorization = comverse_customer_token;
          }

          const payload = {
            method: "GET",
            headers: headers,
          };

          const res = await fetch(
            process.env.NEXT_PUBLIC_BACKEND +
              `/storefront/customer_orders?limit=6&page=${page}`,
            payload
          );

          const data = await res.json();

          if (
            data?.detail === "Invalid auth token" ||
            data?.detail === "Session Expired, Please login your account"
          ) {
            // message.error("Session Expired");
            dispatch(logoutReducer());
            customerLogout();
            router.push("/");
          } else if (!res.ok) {
            throw new Error("Customer Orders Api Api Failed!");
          }

          setActivePage(page);
          setCustomerOrders(data);
          setLoading(false);
          return data;
        } catch (error) {
          console.error("Error fetching data:", error.message);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          return null;
        }
      }
    },
    [comverse_customer_token, router]
  );

  //? Life Cycles ---------------------------------------------------------------->
  useEffect(() => {
    if (comverse_customer_token) {
      fetchCustomerOrders(1);
    }
  }, [comverse_customer_token, fetchCustomerOrders]);

  return (
    <Col span={24} className="OrdersListingModule">
      <Col span={24} className="padding10">
        <Text className="font14Bold poppinsMedium">My Orders</Text>
      </Col>

      <Col span={24} className="ordersHistory marginTop10">
        <Col span={24}>
          <Spin spinning={Loading} delay={500}>
            {CustomerOrders?.results?.length > 0 ? (
              <Col className="marginTop15">
                <Row
                  className="gap10"
                  justify="start"
                  style={{ minHeight: "470px" }}
                >
                  {CustomerOrders?.results?.map((order, index) => {
                    const count = (ActivePage - 1) * 6 + index + 1;

                    return (
                      <Col span={24} className="padding0" key={index}>
                        <OrderCard
                          key={index}
                          count={count}
                          OrderDetail={order}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            ) : (
              <Col span={24} className="marginTop15">
                <Typography className="no-order-found-text-orders-detail-page">
                  No Orders Found
                </Typography>
              </Col>
            )}
          </Spin>
        </Col>

        {CustomerOrders?.results?.length > 0 && (
          <Col
            span={24}
            className="backgroundLight flexCenter padding10 marginTop10"
          >
            <Pagination
              pageSize={6}
              defaultPageSize={6}
              current={ActivePage}
              onChange={fetchCustomerOrders}
              total={CustomerOrders?.count}
            />
          </Col>
        )}
        {/* <Col
          span={24}
          style={{ height: "50px" }}
          className="flexCenter marginTop15 backgroundLight"
        >
          <Space>
            <Button
              shape="circle"
              className="flexCenter"
              icon={<LeftOutlined />}
              onClick={() => fetchCustomerOrders()}
              style={{ background: "#E4E4E4", height: "", width: "26px" }}
            />
            <Text className="font12" style={{ color: "#727272" }}>
              Prev - Next
            </Text>
            <Button
              shape="circle"
              className="flexCenter"
              icon={<RightOutlined />}
              onClick={() => fetchCustomerOrders()}
              style={{ background: "#E4E4E4", height: "", width: "26px" }}
            />
          </Space>
        </Col> */}
      </Col>
    </Col>
  );
}
